import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AnimationOption } from 'library-explorer';
import { SlideDTO } from '@app/model/slideDTO.model';
import { LanguageService } from '@app/services/language.service';

@Component({
    selector: 'app-question-slider',
    templateUrl: './question-slider.component.html',
    styleUrls: ['./question-slider.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => QuestionSliderComponent),
            multi: true
        }
    ],
    standalone: false
})
export class QuestionSliderComponent implements OnInit, ControlValueAccessor {
  @Input() public data: SlideDTO;
  @Input() questionHash: string;
  @Input() animation: AnimationOption = AnimationOption.NONE;
  @Input() animationDelay = 0;
  
  onChange = (data: any) => {};
  onTouched = () => {};

  public answer = null;
  public isRtl = false;

  constructor(
    private readonly languageService: LanguageService
  ) { }

  ngOnInit(): void {
    this.isRtl = this.languageService.isRtl();
  }

  public writeValue(obj: any): void {
    this.answer = obj;
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
